export default "__VITE_ASSET__ddd15da3__"